import React from 'react';

import type { SpacingScale } from '../../utilities/shared/sizes';
import { styled } from '../../stitches.config';
import { AssetTile } from '../AssetTile/AssetTile';

const ProviderIconFromSrcLiteral = styled('img', {
  display: 'flex',
  width: '100%',
  height: '100%',
});
ProviderIconFromSrcLiteral.displayName = 'ProviderIconFromSrcLiteral';

export interface ProviderIconFromSrcProps {
  /**
   * Set icon src of provider to display.
   */
  src: string;
  /**
   * Set a size of the component.
   */
  size?: SpacingScale;
}

export function ProviderIconFromSrc({ src, size = 40, ...remaining }: ProviderIconFromSrcProps) {
  return (
    <AssetTile size={size} unset {...remaining}>
      <ProviderIconFromSrcLiteral src={src} {...remaining} />
    </AssetTile>
  );
}
